import { render, staticRenderFns } from "./TabDepartments.vue?vue&type=template&id=447f9fd2&scoped=true&"
import script from "./TabDepartments.vue?vue&type=script&lang=js&"
export * from "./TabDepartments.vue?vue&type=script&lang=js&"
import style0 from "./TabDepartments.vue?vue&type=style&index=0&id=447f9fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f9fd2",
  null
  
)

export default component.exports